import { useEffect, useRef } from "react";
import { BACKEND_URL, getToken } from "@/api";

// Subscribe to backend websocket events. onEvent receives {type, payload}.
export function useRealtime(onEvent, tokenOverride) {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    let ws;
    let closed = false;
    let retry;
    let ping;

    const connect = () => {
      const token = tokenOverride || getToken();
      if (!token) return;
      const wsBase = BACKEND_URL.replace(/^https/, "wss").replace(/^http/, "ws");
      ws = new WebSocket(`${wsBase}/api/ws?token=${token}`);
      ws.onopen = () => {
        try { cbRef.current && cbRef.current({ type: "__ws_open" }); } catch (_) {}
        clearInterval(ping);
        ping = setInterval(() => { try { if (ws && ws.readyState === 1) ws.send('{"type":"__ping"}'); } catch (_) {} }, 25000);
      };
      ws.onmessage = (e) => {
        try {
          const msg = JSON.parse(e.data);
          cbRef.current && cbRef.current(msg);
        } catch (_) {}
      };
      ws.onclose = () => {
        clearInterval(ping);
        if (!closed) retry = setTimeout(connect, 250);
      };
      ws.onerror = () => {
        try { ws.close(); } catch (_) {}
      };
    };

    connect();
    return () => {
      closed = true;
      clearTimeout(retry);
      clearInterval(ping);
      try { ws && ws.close(); } catch (_) {}
    };
  }, [tokenOverride]);
}
